<template>
  <div class="page-wraper">
    <van-tabs
      v-model="active"
      @change="onSearch()"
      style="margin-bottom: 50px;"
    >
      <van-tab title="待处理" class="tab-content"></van-tab>
      <van-tab title="已处理" class="tab-content"></van-tab>
    </van-tabs>
    <DataList
      ref="dataList"
      class="data-list"
      :api="getDataApi"
      :params="params"
      dataField="Data"
      totalField="Total"
    >
      <template v-slot="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="toDetail(item.ApplyId)"
        >
          <div class="detail-box">
            <div class=" check-room">{{ item.MeetingRoomName }}</div>
            <div class="meeting-name">会议名称：{{ item.MeetingTopic }}</div>
            <div class="check-man">申请人：{{ item.Contact }}</div>
            <div class="begin-time">开始时间：{{ item.BeginTime }}</div>
            <div class="end-time">结束时间：{{ item.EndTime }}</div>
            <div class="phone">电话：{{ item.Phone }}</div>
            <div class="date">2020.02.02</div>
            <div
              class="state"
              v-if="item.OrderStatus == '2' && item.ConfirmResult != '0'"
            >
              已取消
            </div>
            <div class="state" v-else-if="item.ConfirmResult == '1'">
              同意
            </div>
            <div class="state" v-else-if="item.ConfirmResult == '0'">
              已取消
            </div>
            <div class="state" v-else>
              未审批
            </div>
          </div>
        </div>
      </template>
    </DataList>
    <van-search
      v-model="value"
      show-action
      placeholder="搜索"
      @search="onSearch"
      class="searchBox"
    >
      <template #action>
        <div
          @click="onShowSearch"
          style="color: rgb(150,150,150);font-weight: bold;"
        >
          <van-icon name="filter-o" />筛选
        </div>
      </template>
    </van-search>
  </div>
</template>

<script>
import queryPopup from "./queryPopup";
import moment from "moment";
import buildingManagementApi from "@/api/buildingManagement";
import DataList from "@/components/DataList";
import { mapState } from "vuex";
export default {
  data() {
    return {
      active: 0,
      value: "",
      params: {},
      getDataApi: buildingManagementApi.QueryMeetingRoomApply,
    };
  },
  components: {
    DataList,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    if (
      !this.userInfo.Permissions.includes(
        "MainMenu./预订场地./预订场地/申请审批"
      )
    ) {
      this.$router.replace({ path: "/noPermissions" });
    }
    this.onSearch();
  },
  methods: {
    toDetail(applyId) {
      this.$router.push({
        name: "checkDetail",
        query: { applyId: applyId },
      });
    },
    onSearch(params) {
      console.log(this.active);
      this.params = Object.assign(this.params, params, {
        OrderStatus: [this.active + ""],
      });
      this.$nextTick(() => {
        this.$refs.dataList.reload();
      });
      // buildingManagementApi
      //   .QueryMeetingRoomApply({
      //     ...params,
      //     pageIndex: 0,
      //     pageSize: 9999,
      //   })
      //   .then((res) => {
      //     console.log(res)
      //   })
    },

    onShowSearch() {
      // const { billDate } = this.userInfo
      queryPopup({
        defaultSearchData: {
          // date: [
          //   moment(billDate)
          //     .subtract(1, "d")
          //     .format("YYYY-MM-DD"),
          //   moment(billDate)
          //     .add(10, "d")
          //     .format("YYYY-MM-DD"),
          // ],
        },
        formData: this.params,
        submit: (values) => {
          const json = {};
          for (const key in values) {
            if (values[key]) {
              json[key] = values[key];
            }
          }
          const params = {
            ...values,
            BeginDate:
              json.date && json.date.length
                ? moment(json.date[0]).format("YYYY-MM-DD")
                : "",
            EndDate:
              json.date && json.date.length
                ? moment(json.date[1]).format("YYYY-MM-DD")
                : "",
          };
          this.params = params;
          this.onSearch(params);
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-wraper {
  padding-bottom: 0px;
  min-height: 100vh;
  position: relative;
  .tab-content {
    padding-top: 54px;
  }
}
/deep/.van-search__content {
  background-color: rgb(237, 237, 239);
  border-radius: 5px;
}
/deep/.van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  color: rgb(150, 150, 150);
}
/deep/.van-tabs__line {
  background-color: #000;
  width: 20px;
  border-radius: 50px;
  height: 3px;
}
/deep/.van-tab {
  color: rgb(150, 150, 150);
}
/deep/.van-tab--active {
  color: #000;
  font-weight: bold;
}
/deep/.van-tabs__wrap {
  border-bottom: 2px solid rgb(245, 245, 245);
  padding-bottom: 3px;
  height: 40px;
}
/deep/ .van-search {
  height: 50px;
}
.searchBox {
  position: absolute;
  top: 92px;
  left: 0;
  width: 100%;
  z-index: 99;
}
.data-list {
  height: calc(100vh - 140px);
  overflow-y: scroll;
  .detail-box {
    div {
      margin-bottom: 3px;
    }
    position: relative;
    width: 95%;
    margin: 0 auto;
    padding: 10px 0;
    border-bottom: 1px solid #c0c0c04c;
    font-size: 12px;
    color: #777777e0;
    .check-room {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 8px;
      color: #000;
      width: 80%;
    }
    .date {
      position: absolute;
      right: 0;
      top: 15px;
    }
    .state {
      position: absolute;
      right: 0;
      bottom: 10px;
    }
  }
}
</style>
